import classnames from "classnames";
import React, { FC, memo } from "react";

import { testAttr } from "@/browser";

import { Flex } from "../../../Flex";
import { IDataTableProps } from "../../types";
import { IRowComponentProps, RowComponent as RowComponentBase } from "../RowComponent";

export interface IGroupRowProps<T = any>
  extends Pick<
      IDataTableProps<T>,
      "columns" | "ExpandedRowComponent" | "RowComponent" | "autoHeight" | "testName" | "className"
    >,
    Pick<IRowComponentProps, "rowData" | "isExpanded" | "expandIcon" | "collapseIcon" | "onExpandRowClick" | "index"> {}

const GroupRowComponentBase: FC<IGroupRowProps> = props => {
  const {
    autoHeight,
    collapseIcon,
    columns,
    ExpandedRowComponent,
    expandIcon,
    index,
    isExpanded,
    onExpandRowClick,
    RowComponent,
    rowData,
    className,
  } = props;

  const classNames = classnames(
    "data-table__row-group",
    {
      "row-group--expanded": !!isExpanded,
    },
    className,
  );

  const TableRow = RowComponent ? RowComponent : RowComponentBase;

  const grTestableProps = testAttr(props, { sufix: "data-table__group-row", id: index });

  return (
    <Flex direction="column" className={classNames} {...grTestableProps}>
      <TableRow
        autoHeight={autoHeight}
        collapseIcon={collapseIcon}
        columns={columns}
        expandable={!!ExpandedRowComponent}
        expandIcon={expandIcon}
        index={index}
        isExpanded={isExpanded}
        onExpandRowClick={onExpandRowClick}
        rowData={rowData}
      />
      {ExpandedRowComponent && isExpanded && <ExpandedRowComponent rowData={rowData} columns={columns} index={index} />}
    </Flex>
  );
};

export const GroupRowComponent = memo(GroupRowComponentBase);
